import styled from 'styled-components'
import { CloseButton } from '@/features/shared/components/CloseButton'
import { useMediaQuery } from '@/features/shared/hooks/useMediaQuery'
import { Box } from '@shipt/design-system-layouts'

type Props = {
  width?: string
  togglePopover: () => void
  willOverflow?: boolean
  children: React.ReactNode
}
export const PopoverMaxWidth = 315

export const FilterPopover = ({
  children,
  width = '100%',
  togglePopover,
  willOverflow = false,
}: Props) => {
  const { screenSm } = useMediaQuery()

  if (screenSm) return null
  return (
    <FilterPopoverWrapper willOverflow={willOverflow}>
      <FilterWrapperDiv width={width}>
        <ChildrenWrapperDiv>{children}</ChildrenWrapperDiv>
        <Box padding={[0, 'sm']}>
          <CloseButton onClick={togglePopover} aria-label="close filter popup" />
        </Box>
      </FilterWrapperDiv>
    </FilterPopoverWrapper>
  )
}

const FilterPopoverWrapper = styled.div<{ willOverflow: boolean }>`
  position: absolute;
  right: ${({ willOverflow }) => (willOverflow ? '0.5rem' : 'unset')};
  z-index: 500;
`

const FilterWrapperDiv = styled.div<{ width: string }>`
  box-shadow: 0 0 11px 0 rgb(0 0 0 / 10%);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 8px 16px 16px;
  min-width: 17.5rem;
  max-width: ${PopoverMaxWidth}px;
  width: ${({ width }) => width};
  background: ${({ theme }) => theme.white};
  border-radius: 16px;
  max-height: calc(100vh - 18.75rem);
  overflow: auto;
  overscroll-behavior: contain;
`

const ChildrenWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
`
